import {getCookie} from './cookie'
import ElementUI from 'element-ui'

export default function setAxiosConfig (axios) {
  let service = axios.create({
    withCredentials: true,
    timeout: 10000 // request timeout
  })
  service.defaults.withCredentials = true
  // request interceptor
  service.interceptors.request.use(
    async (config) => {
      // Do something before request is sent
      if (getCookie('token')) {
        config.headers['Authorization'] = `${JSON.parse(getCookie('user')).token}`
      }
      return config
    },
    error => {
      // Do something with request error
      // ElementUI.Message({
      //   message: error,
      //   type: 'error'
      // })
      console.log(error) // for debug
      Promise.reject(error)
    }
  )

  // response interceptorve-line
  service.interceptors.response.use(
    response => {
      if (response.data.code === 0 || response.data.code === 2000 || response.data.code == 200 || response.logout) {
        // 正常请求要做的事
        return response
      } else if (response.data.code === 2013 || response.data.code === 2013 || response.logout) {
        // 无效token
        // ElementUI.Message({
        //   message: response.data.message + ',请重新登录',
        //   type: 'error'
        // })
        setTimeout(() => {
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          window.location.href = '#/login'
        }, 1000)
      } else {
        // 异常请求要做的事
        // console.log('ll')
        // ElementUI.Message({
        //   message: response.data.message,
        //   type: 'error'
        // })
        return response
      }
    },
    error => {
      console.log(error, 222)
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      window.location.href = '#/login'
      ElementUI.Message({
        message: 'Token失效，请重新登录',
        type: 'error'
      })
      // 返回接口返回的错误信息
      return Promise.reject(error.response)
    }
  )

  return service
}



// WEBPACK FOOTER //
// ./src/utils/setAxiosConfig.js